import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LoginPage from '../../pages/auth/LoginPage';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { currentUser } = useAuth();

  return currentUser ? <>{children}</> : <LoginPage />;
};

export default ProtectedRoute;
